import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportAccountReceiable extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.customerType!=undefined) {
            ReportStore.loadReportAccountReceivable(this.props.year,this.props.month,this.props.day,this.props.customerType,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.customerType!=undefined) {
            ReportStore.loadReportAccountReceivableRange(this.props.startDate,this.props.endDate,this.props.customerType,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={3}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-left'>{item.customer_name}</td>
              <td className='text-center'>{item.wait_finance_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.wait_finance_amount)}</td>
              <td className='text-center'>{item.wait_payment_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.wait_payment_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.total_amount)}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        // let {type} = this.props
        return(
            <table className='table table-print-report-sales-tax'>
                <tbody>
                    <tr>
                        <td rowSpan={2} className='text-center' style={{width:'250px'}}>ลูกค้า/ประกัน</td>
                        <td colSpan={2} className='text-center'>ยอดรวมค้างตั้งเบิก</td>
                        <td colSpan={2} className='text-center'>ยอดรวมค้างรับ</td>
                        <td rowSpan={2} className='text-center' style={{width:'110px'}}>รวมยอดค้าง</td>
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'70px'}}>จ็อบ</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนเงิน</td>
                        <td className='text-center' style={{width:'70px'}}>จ็อบ</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนเงิน</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getSummary('wait_finance_count')}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_finance_amount'))}</td>
                        <td className='text-center'>{this.getSummary('wait_payment_count')}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('wait_payment_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('total_amount'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportAccountReceiable.defaultProps = {
    title: 'ตารางรายงานงวดตั้งเบิกค้างรับ',
    mode: '',
    workNo: ''
  }
  export default PrintReportAccountReceiable;


// WEBPACK FOOTER //
// ./src/view/print/finance/PrintReportAccountReceiable.js